<template>
  <div class="followup-item" :class="{ 'show-dynamic-border': desc.aiTodoSuggestTag === 1 }">
    <div class="desc-title">
      <div class="desc-title-left">
        <i v-if="!desc.match" class="icon-alert-fill t-iconfont"></i>
        <i v-else class="icon-checkbox-circle-fill t-iconfont"></i>
        <span>{{ desc.name }}</span>
      </div>
      <div v-if="showNewBtn" class="ai-new" @click="handleCreateTodoSuggest">
        <i class="icon-quill-pen-ai2-fill t-iconfont"></i>
        <span class="text">AI跟进建议</span>
      </div>
    </div>
    <div class="desc-content">{{ desc.description }}</div>
    <template v-if="props.isShow">
      <div v-if="desc.aiTodoSuggestTag === 1" class="desc-todo-ai">
        <aiBox>
          <template #content> </template>
        </aiBox>
      </div>
      <div v-else-if="desc.aiTodoSuggestTag === 2" class="desc-todo">
        <div class="success-tips">
          <div class="success-tips__left">
            <img alt="" :src="aiLogo" />
            <span>小助手已为你提供“{{ desc.name }}”的建议创建待办</span>
          </div>
          <div class="success-tips__right"></div>
        </div>
        <div class="remind-list">
          <remind
            v-for="(suggest, index) in desc.todoSuggest"
            :key="index"
            :attributes="{ ...attributes, index: desc.index }"
            :item="suggest"
          ></remind>
        </div>
      </div>
      <!-- <div class="desc-todo" v-else-if="createClick && createAndNew && !showAi">
        <div class="success-tips default-box">
          <div class="success-tips__left">
            <i class="icon-calendar-2-line t-iconfont"></i>
            <span>已根据 AI 助手的建议创建待办</span>
          </div>
          <div class="success-tips__right">查看详情</div>
        </div>
      </div> -->
      <div v-else-if="desc.aiTodoSuggestTag === 3" class="desc-todo">
        <div class="success-tips">
          <div class="success-tips__left">
            <img alt="" :src="aiLogo" />
            <span>知识库内暂无相关知识，小助手无法分析，请先完善知识库</span>
          </div>
          <div class="success-tips__right">
            <span @click="handleReNew">重新生成</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import aiLogo from '@/assets/ai-logo.png'
import remind from './remind.vue'
import aiBox from './ai-box.vue'
import { createTodoSuggest, getSseMsg } from '@/api/index.js'

const emits = defineEmits(['handle-new-remind', 'getRemind', 'refreshList', 'refreshCard'])

const props = defineProps({
  desc: {
    type: Object,
    default: () => ({})
  },
  isShow: {
    // 二期内容 暂时不展示
    type: Boolean,
    default: true
  },
  aiKey: {
    type: String,
    default: ''
  },
  attributes: {
    type: Object,
    default: () => ({})
  }
})

// 未生成
const showNewBtn = computed(() => {
  return !props.desc.match && !props.desc.aiTodoSuggestTag && 0
})

const handleCreateTodoSuggest = () => {
  // emits('refreshCard', {})
  createTodoSuggest({
    key: props.aiKey,
    customerId: props.attributes.customer?.customerId,
    index: props.desc.index,
    chatRecordId: props.attributes.id,
    scoreRuleId: props.attributes.scoreRuleId,
    name: props.desc.name
  }).then((res) => {
    emits('getRemind')
    getSseMsg({ chatRecordId: res.result?.chatRecordId })
      .then((sseData) => {
        console.log(sseData)
        emits('refreshCard', sseData)
      })
      .catch((err) => {
        emits('refreshList')
        console.log('followup-item:handleCreateTodoSuggest', err)
      })
  })
}

const handleReNew = () => {
  handleCreateTodoSuggest()
}
</script>

<style lang="less" scoped>
.followup-item {
  border: 1px solid #f2f3f5;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  position: relative;
  font-family: PingFang SC;
  .desc-title {
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    line-height: 20px;
    .desc-title-left {
      color: #323233;
      .icon-checkbox-circle-fill {
        color: #00c241;
        margin-right: 4px;
      }
      .icon-alert-fill {
        color: #ffb521;
        margin-right: 4px;
      }
    }
    .ai-new {
      cursor: pointer;
      i {
        margin-right: 6px;

        background: linear-gradient(285deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
      .text {
        background: linear-gradient(285deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
    }
  }
  .desc-content {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    color: #969799;
  }
  .desc-todo {
    margin-top: 8px;
    .success-tips {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 12px;
      border-radius: 4px;
      background: linear-gradient(95deg, #e9ecfa 8%, #dfeeff 100%);
      .success-tips__left {
        display: flex;
        font-family: PingFang SC;
        font-size: 14px;
        color: #323233;
        align-items: flex-start;
        img {
          height: 20px;
          width: 20px;
          margin-right: 8px;
        }
        span {
          line-height: 20px;
        }
      }
      .success-tips__right {
        flex: 0 0 auto;
        font-family: PingFang SC;
        font-size: 12px;
        color: #248df5;
      }
    }
    .default-box {
      background: #f7f8fa;
      .success-tips__left {
        align-items: center;
        i {
          margin-right: 8px;
        }
      }
    }
  }

  .desc-todo-ai {
    position: relative;
    height: 50px;
    .ai-box {
      padding: 0 12px;
      .item {
        margin-top: 12px;
      }
    }
  }
}
</style>
